const validate = (value, {data: options}) => {
    if (Array.isArray(value)) {
        return value.every(val => validate(val, {data: options}));
    }

    return !! options.filter(option => option == value).length
}

export default validate
